import { useNavigate } from 'react-router-dom';
import { cleareCookies } from '../../services/Cookies.js';
import toast from 'react-hot-toast';
import {api} from '../../api/index.js';
import { useDispatch } from 'react-redux';
import { setLoggedIn } from "../../store/Slices/userSlice.js"; // Corrected import

let errorToastId = null;

const showErrorToast = (message) => {
    if (errorToastId) {
        return;
    }
    errorToastId = toast.error(message, {
        onClose: () => {
            // Reset the errorToastId when the toast is closed
            errorToastId = null;
        }
    });
};

export default function SessionManager() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    api.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            if (error.response?.status === 401) {
                dispatch(setLoggedIn(false));  // Use correct action here
                cleareCookies();
                showErrorToast('Your session has expired. Please login to pick up where you left off.');
                navigate('/'); // Navigate to login page
            }
            return Promise.reject(error);
        }
    );

    return null;  // This ensures the component is a valid React component and doesn't render anything
}
